import { Typography, styled } from '@mui/material';

export const ErrorLoginTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.error.main,
}));

export const ForgotPWStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  cursor: 'pointer',
}));
